
/**
 * Example
 * window.addEventListener('DOMContentLoaded', () => {
  initCriticalUI();

  // 나머지는 lazy로
  lazyRun(() => initTooltip());
  lazyRun(() => initABTest());
});
lazyRun(() => {
  // 이 모듈이 로드되면, 실행은 idle에
  setupFeatureX();
});
 */
window.lazyRun = (function () {
  var taskQueue = [];
  var started = false;
  var loadHooked = false;
  var scheduled = false;
  var TIMEOUT = 2000; //2sec wait idle time
  var FALLBACK_BATCH = 5;

  function safeThrow(e) { setTimeout(function () { throw e; }); }

  function schedule() {
    if (!started || scheduled) return;
    scheduled = true;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: TIMEOUT });
    } else {
      setTimeout(function () { run(null); }, 1);
    }
  }

  function run(deadline) {
    scheduled = false;

    if (deadline) {
      while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && taskQueue.length) {
        var task = taskQueue.shift();
        try { task(); } catch (e) { safeThrow(e); }
      }
    } else {
      // 폴백: 너무 오래 점유하지 않게 배치 처리
      for (var i = 0; i < FALLBACK_BATCH && taskQueue.length; i++) {
        var t = taskQueue.shift();
        try { t(); } catch (e) { safeThrow(e); }
      }
    }

    if (taskQueue.length) schedule();
  }

  function start() {
    if (started) return;
    started = true;
    schedule();
  }

  return function (task) {
    console.log('lazyRun');
    taskQueue.push(task);

    if (document.readyState === 'complete') {
      start();
    } else if (!loadHooked) {
      loadHooked = true;
      window.addEventListener('load', start);
    }

    if (started) schedule();
  };
})();

const finalRedirectUrl = localStorage.getItem('finalRedirectUrl');
if (finalRedirectUrl && finalRedirectUrl !== window.location.href) {
  window.location.href = finalRedirectUrl;
}
localStorage.removeItem('finalRedirectUrl');

document.addEventListener('click', function (event) {
  var closeButton = event.target.closest('.hulk_notification_container .notification_close');
  if (!closeButton) return;
  document.querySelectorAll(".hulkWishListOverlay").forEach(function (overlay) {
    overlay.classList.remove("hulkWishListOverlay");
  });
});

function zendeskInterval() {
  if (typeof zE === 'function') {
    zE('messenger', 'close');
  }

  const zendeskInterval = setInterval(() => {
    const iframe = document.querySelector('iframe[id="launcher"]');
    if(!iframe) return;
    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    iframe.style.borderRadius = "50%";
    iframe.style.width = "48px";
    iframe.style.height = "48px";
    iframe.style.right = "20px";
    iframe.style.bottom = "30px";
    const style = iframeDocument.createElement('style');
    style.innerHTML = `
            .IRbBD{
              width: 48px !important;
              height: 48px !important;
              background-color: #c41320 !important;
            }
             .cfVHfL{
              width: 48px !important;
              height: 48px !important;
              background-color: #c41320 !important;
            }   
            button[class*="StyledIconButton"]{ background-color: #c41320 !important; border-color: #c41320 !important;}
          `;
    iframeDocument.head.appendChild(style);
    
    const iframeParent = iframe.closest("div");
    const needHelpDiv = iframeParent ? iframeParent.querySelector("div") : null;
    if(needHelpDiv) {
      needHelpDiv.style.display = "none!important";
      needHelpDiv.style.opacity = "0";
      needHelpDiv.style.zIndex = "-1";

      iframe.classList.add('loaded');
      clearInterval(zendeskInterval)
    }
  }, 300)

  setTimeout(() => clearInterval(zendeskInterval), 15000)
}

var isHasSupported = false;

if (window.CSS && window.CSS.supports) {
  isHasSupported = CSS.supports('selector(:has(*))');
}

if (isHasSupported) {
  lazyRun(zendeskInterval);
} else {
  document.addEventListener('DOMContentLoaded', function () {
    zendeskInterval();
  });
}


{
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    document.querySelectorAll('[data-desktop-only]').forEach(el => {
      el.remove();
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {

  function toggleHeartIconVisibility() {
    var heartIcons = document.querySelectorAll('.heart-hulk-animation.hulkapps-wl-collection-icon');
    if (!heartIcons.length) return;

    heartIcons.forEach(function (heartIcon) {
      if (window.location.href === "https://levi.co.kr/") {
        heartIcon.style.display = 'none';
      } else {
        heartIcon.style.display = '';
      }
    });
  }

  var observer = new MutationObserver(toggleHeartIconVisibility);
  observer.observe(document.body, { childList: true, subtree: true });


  const returnToShopButton = document.querySelector('.empty_content .wishlist-btn');
  if (returnToShopButton) {
    returnToShopButton.setAttribute('href', '/account');
    returnToShopButton.textContent = '나의 페이지';
  }

  const accountLink = document.querySelector(".hulk__wishlist-wrap .fancy_title p a");
  if (accountLink) {
    accountLink.setAttribute("href", "/pages/mypage");
  }
});

